export default __webpack_public_path__ + "static/comment-8ea61628a811d7bff63048734cceccd3.png";